module.exports = __webpack_public_path__ + "img/lct.4b2a6eab.svg";